import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from '../value-accessors/object-value-accessor';

/**
 * For when you need a radio list but you need to be able to uncheck the selected radio button.
 * (can't actually use radio buttons, cuz they suck)
 * Works differently than a standard checkbox, because Angular only supports true/false values. This supports any value.
 *
 * Usage:
 *
 * <label><wl-radio-checkbox [(ngModel)]="params.Color" [value]="Blue" [uncheckedValue]="Red" /> Blue</label>
 * <label><wl-radio-checkbox [(ngModel)]="params.Color" [value]="Green" [uncheckedValue]="Red" /> Green</label>
 * <label><wl-radio-checkbox [(ngModel)]="params.Color" [value]="Yellow" [uncheckedValue]="Red" /> Yellow</label>
 *
 */
@Component({
  selector: 'wl-radio-checkbox',
  templateUrl: 'radio-checkbox.component.html',
  providers: [CreateObjectValueAccessorProvider(WlRadioCheckboxComponent), CreateObjectValueValidationProvider(WlRadioCheckboxComponent)],
    standalone: false
})
export class WlRadioCheckboxComponent extends ObjectValueAccessor<any> {
  @Input() disabled: boolean = false;

  /**
   * value to set the model to when the checkbox is checked
   */
  @Input('value') checkboxValue: any = null;

  /**
   * the value to set to the model when the checkbox is unchecked
   */
  @Input() uncheckedValue: any = null;

  public constructor() {
    super(null, true);
  }

  public handleClick(event: Event): void {
    if (!event && !event.target) return;

    let newValue: any = <any>(<HTMLInputElement>event.target).value;

    // fires before setting the new value to the model
    // so if it's the same, they clicked it twice
    if (this.value == newValue) newValue = this.uncheckedValue;

    setTimeout(() => (this.value = newValue));
  }
}
